/* ─────────────────────────────────────────────────────────────────────────
 * One GSAP for the whole desk.
 *
 * Every animated surface imports gsap FROM HERE rather than from the package,
 * so the plugin registration happens exactly once and the easing vocabulary is
 * shared: `DESK_EASE` is the curve the section's own CSS entrances use, which
 * is what makes canvas motion and DOM motion read as one hand.
 *
 * ScrollTrigger touches `window` on registration, so it is registered behind a
 * browser check — this module is imported by components that also render on
 * the server.
 * ───────────────────────────────────────────────────────────────────────── */

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger)
}

/** The desk's easing — the same settle as cubic-bezier(.16,1,.3,1). */
export const DESK_EASE = 'power3.out'

export { gsap, ScrollTrigger }
